<!-- Country -->
<div class="terra-form-field-wrapper country-wrapper" *ngIf="formSettings.toShowField(AddressFields.Country)">
  <label [for]="'aucCountryId_' + instanceId" class="text-input-label"> {{textForFiled('Country', isCountryRequired())}}</label>
  <mat-form-field appearance="outline">
    <terra-country-input [inputId]="'aucCountryId_' + instanceId" [formControl]="addressForm.get('countryId')" placeholder="Select country" matInput [disableControl]="lockUsaCountry">
    </terra-country-input>
    <mat-error *ngIf="addressForm.get('countryId').hasError('required')">Required</mat-error>
  </mat-form-field>
</div>

<!-- Street name -->
<div class="terra-form-field-wrapper street-wrapper" *ngIf="formSettings.toShowField(AddressFields.Street)">
  <label [for]="'txtStreetName_' + instanceId" class="text-input-label"> {{textForFiled('Street Address', formSettings.toRequireField(AddressFields.Street))}}</label>
  <mat-form-field appearance="outline">
    <input #street1 [id]="'txtStreetName_' + instanceId" [formControl]="addressForm.get('streetName')" matInput class="lo_sensitive capitalize"/>
    <mat-error *ngIf="addressForm.get('streetName').hasError('required')"> Required</mat-error>
  </mat-form-field>
</div>

<!-- Street 2 -->
<div class="terra-form-field-wrapper street-wrapper" *ngIf="formSettings.toShowField(AddressFields.Street2)">
  <label [for]="'txtStreetName2_' + instanceId"
         class="text-input-label"> {{textForFiled('Second line of address', formSettings.toRequireField(AddressFields.Street2))}}</label>
  <mat-form-field appearance="outline">
    <input #street2 [id]="'txtStreetName2_' + instanceId" [formControl]="addressForm.get('street2Name')" matInput
           class="lo_sensitive capitalize"/>
    <mat-error *ngIf="addressForm.get('street2Name').hasError('required')"> Required</mat-error>
  </mat-form-field>
</div>

<!-- City -->
<div class="terra-form-field-wrapper city-wrapper" *ngIf="formSettings.toShowField(AddressFields.City)">
  <label [for]="'txtCityName_' + instanceId"
         class="text-input-label"> {{textForFiled('City', formSettings.toRequireField(AddressFields.City))}}</label>
  <mat-form-field appearance="outline">
    <input #city [id]="'txtCityName_' + instanceId" [formControl]="addressForm.get('cityName')" matInput
           class="lo_sensitive capitalize"/>
    <mat-error *ngIf="addressForm.get('cityName').hasError('required')"> Required</mat-error>
  </mat-form-field>
</div>

<!-- State -->
<div class="terra-form-field-wrapper state-wrapper">
  <label [for]="'ddlStateName_' + instanceId" class="text-input-label"> {{textForFiled('State', formSettings.stateRequiredWhileUs)}}</label>
  <mat-form-field appearance="outline">
    <mat-select #stateSelect [formControl]="addressForm.get('stateName')" [id]="'ddlStateName_' + instanceId"
                placeholder="Select" [disableControl]="addressForm.get('countryId').value !== USCountryId || (!lockUsaCountry && addressForm.get('countryId').disabled)">
      <mat-option *ngFor="let stateOption of allStates" [value]="stateOption.name"> {{ stateOption.name }} </mat-option>
    </mat-select>
    <mat-error *ngIf="addressForm.get('stateName').hasError('required')"> Required</mat-error>
  </mat-form-field>
</div>

<!-- House number & postal code -->
<div class="terra-form-field-wrapper house-number-postal-code-wrapper house-number-postal-code"
     *ngIf="formSettings.toShowField(AddressFields.PostalCode) && formSettings.toShowField(AddressFields.HouseNumber)">
  <!-- House number -->
  <label [for]="'txtHouseNumber_' + instanceId" class="text-input-label house-label"> {{textForFiled('House number', formSettings.toRequireField(AddressFields.HouseNumber))}}</label>
  <mat-form-field appearance="outline" class="house-field-wrapper">
    <input #houseNumber [id]="'txtHouseNumber_' + instanceId" [formControl]="addressForm.get('houseNumber')" matInput
           class="lo_sensitive"/>
    <mat-error *ngIf="addressForm.get('houseNumber').hasError('required')"> Required</mat-error>
  </mat-form-field>
  <!-- Postal code -->
  <label [for]="'txtPostalCode_' + instanceId" class="text-input-label postal-label"> {{textForFiled('Postal Code', formSettings.toRequireField(AddressFields.PostalCode))}}</label>
  <mat-form-field appearance="outline" class="postal-field-wrapper">
    <input #postalCode [id]="'txtPostalCode_' + instanceId" [formControl]="addressForm.get('postalCode')" matInput
           class="lo_sensitive uppercase"/>
    <mat-error *ngIf="addressForm.get('postalCode').hasError('required')"> Required</mat-error>
    <mat-error *ngIf="addressForm.get('postalCode').hasError('pattern')"> Please enter a valid postal code</mat-error>
  </mat-form-field>
</div>

<!-- Postal code -->
<div class="terra-form-field-wrapper postal-code-wrapper"
     *ngIf="formSettings.toShowField(AddressFields.PostalCode) && !formSettings.toShowField(AddressFields.HouseNumber)">
  <label [for]="'txtPostalCodeOnly_' + instanceId" class="text-input-label postal-label">{{textForFiled('Postal Code', formSettings.toRequireField(AddressFields.PostalCode))}}</label>
  <mat-form-field appearance="outline" class="postal-field-wrapper">
    <input #postalCodeOnly [id]="'txtPostalCodeOnly_' + instanceId" [formControl]="addressForm.get('postalCode')"
           matInput
           class="lo_sensitive uppercase"/>
    <mat-error *ngIf="addressForm.get('postalCode').hasError('required')"> Required</mat-error>
    <mat-error *ngIf="addressForm.get('postalCode').hasError('pattern')"> Please enter a valid postal code</mat-error>
  </mat-form-field>
</div>

<!-- House number -->
<div class="terra-form-field-wrapper house-number-wrapper"
     *ngIf="!formSettings.toShowField(AddressFields.PostalCode) && formSettings.toShowField(AddressFields.HouseNumber)">
  <label [for]="'txtHouseNumberOnly_' + instanceId" class="text-input-label house-label">{{textForFiled('House number', formSettings.toRequireField(AddressFields.HouseNumber))}}</label>
  <mat-form-field appearance="outline" class="house-field-wrapper">
    <input #houseNumberOnly [id]="'txtHouseNumberOnly_' + instanceId" [formControl]="addressForm.get('houseNumber')"
           matInput class="lo_sensitive"/>
    <mat-error *ngIf="addressForm.get('houseNumber').hasError('required')"> Required</mat-error>
  </mat-form-field>
</div>
